import { render } from "./SaveImmigration.vue?vue&type=template&id=1981d464"
import script from "./SaveImmigration.vue?vue&type=script&lang=js"
export * from "./SaveImmigration.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__